import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forma-de-pagos',
  templateUrl: './forma-de-pagos.component.html',
  styleUrls: ['./forma-de-pagos.component.css']
})
export class FormaDePagosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
